<template>
  <el-container id="glDevListSon">
    <el-header style="height:38px;line-height:30px;padding:0;margin:0;background:#F4F4F4">
      <div style="display:flex;white-space: nowrap;">
        <p v-for="l in li_h_text" :style="{color:l.colour,lineHeight:0.3}">{{ l.text }} ></p>
        <p style="color:#000000;line-height:0.3;margin-left:5px;font-weight: bold;">{{ h_text }}</p>
      </div>
    </el-header>
    <el-container class="div_main">
      <el-main style="background: #FFFFFF;">
        <p style="font-size:25px;margin-left:25px;font-weight:bold;">{{ h_text }}</p>
        <div style="display:flex;justify-content:center;align-items:center;">
          <span style="width:80px; margin-left:0.5vw; color: #000000; font-size: 13px">
            设备名称：
          </span>
          <el-input
              placeholder="请输入设备名称"
              style="width:10vw;"
              clearable
              v-model="devName">
          </el-input>
        </div>
        <div style="display:flex;justify-content:center;align-items:center;margin-top:15px">
          <span style="width:80px;margin-left:0.5vw; color: #000000; font-size: 13px">
            设备Did：
          </span>
          <el-input
              v-if="h_text==='新增设备'"
              placeholder="请输入设备Did"
              style="width:10vw;"
              clearable
              v-model="devMac">
          </el-input>
          <el-input
              v-else
              placeholder="请输入设备Did"
              style="width:10vw;"
              clearable disabled
              v-model="devMac">
          </el-input>
        </div>
        <div style="display:flex;justify-content:center;align-items:center;margin-top:15px">
          <span style="width:80px;margin-left:0.5vw; color: #000000; font-size: 13px">
               设备类型：
          </span>
          <el-select v-model="edi_pid" ref='devSonSelect' v-if="h_text==='新增设备'"
                     @click.native="getPid()"
                     clearable filterable placeholder="请选择"
                     style="width:10vw;">
            <el-option
                v-for="item in li_pid"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
          <el-select v-model="edi_pid" ref='select' v-else
                     @visible-change='show_change' disabled
                     clearable filterable placeholder="请选择"
                     style="width:10vw;">
            <el-option
                v-for="item in li_pid"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div v-if="h_text==='新增设备'" style="display:flex;justify-content:center;align-items:center;margin-top:15px">
          <span style="width:80px;margin-left:0.5vw; color: #000000; font-size: 13px">
            所属楼栋：
          </span>
          <el-select v-model="edi_buildId" ref='select1' @change="getFloor('build')"
                     @visible-change='show_change1'
                     filterable placeholder="请选择"
                     style="width:10vw;">
            <el-option
                v-for="item in li_build"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div v-if="h_text==='新增设备'" style="display:flex;justify-content:center;align-items:center;margin-top:15px">
            <span style="width:80px;margin-left:0.5vw; color: #000000; font-size: 13px">
               所属楼层：
            </span>
          <el-select v-model="edi_floorId" ref='select2' @change="getFloor('floor')"
                     @visible-change='show_change2' @click.native="checkLd()"
                     clearable filterable placeholder="请选择"
                     style="width:10vw;">
            <el-option
                v-for="item in li_floor"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div v-if="h_text==='新增设备'" style="display:flex;justify-content:center;align-items:center;margin-top:15px">
            <span style="width:80px;margin-left:0.5vw; color: #000000; font-size: 13px">
               所属房间：
            </span>
          <el-select v-model="edi_roomId" ref='select3' @click.native="checkLd()"
                     @visible-change='show_change3'
                     clearable filterable placeholder="请选择"
                     style="width:10vw;">
            <el-option
                v-for="item in li_room"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div>
          <div style="display:flex;justify-content:center;align-items:center;margin-top:55px">
            <el-button @click="onBack" size="medium">取消</el-button>
            <el-button @click="onKeep" size="medium" type="primary">保存</el-button>
          </div>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>

export default {
  name:"glDevListSon",
  computed:{},
  data() {
    return {
      li_area:[],
      li_buildInfo:[],
      h_text:"新增设备",
      li_h_text:[
        {"text":"管理设置","colour":"#B7B7B7","pages":""},
        {"text":"设备管理","colour":"#B7B7B7","pages":""}
      ],
      id:"",
      isCtr:true,
      edi_pid:"",
      li_pid:[],
      page:1,
      pageSize:30,
      pidPage:1,
      pidPageSize:10,
      pidTotal:10,
      devName:"",
      devMac:"",
      item:0,
      edi_buildId:"",
      li_build:[],
      edi_floorId:"",
      li_floor:[],
      edi_roomId:"",
      li_room:[],
      loading:false, // 是否正在加载中，防止重复加载
      hasMore:true
    };
  },
  methods:{ /*方法存放*/
    handleSelectMenu(path) { /*左侧导航栏事件*/
      console.log(path);
      this.$router.push({path:path}); /*路由跳转*/
    },
    show_change(item) {
      if (item) {
        this.$refs.select.focus();
      } else {
        this.$refs.select.blur();
      }
    },
    show_change1(item) {
      if (item) {
        this.$refs.select1.focus();
      } else {
        this.$refs.select1.blur();
      }
    },
    show_change2(item) {
      if (item) {
        this.$refs.select2.focus();
      } else {
        this.$refs.select2.blur();
      }
    },
    show_change3(item) {
      if (item) {
        this.$refs.select3.focus();
      } else {
        this.$refs.select3.blur();
      }
    },
    onKeep() {
      if (this.isCtr) {
        this.isCtr = false;
        if (this.h_text === '新增设备') {
          this.addUser();
        } else {
          this.changeDev();
        }
        setTimeout(() => {
          this.isCtr = true;
        },600);
      }
    },
    addUser() {
      const params = {
        'name':this.devName,
        'did':this.devMac,
        'pid':this.edi_pid,
        'projectId':localStorage.getItem("projectId")
      };
      if (this.edi_floorId || this.edi_roomId) {
        if (this.edi_roomId) {
          params['roomId'] = this.edi_roomId;
        } else {
          params['floorId'] = this.edi_floorId;
        }
      } else {
        this.$message.error("请先选择楼栋或者房间");
        return;
      }
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.addDevice,params,headers).then(res => {
        console.log(res.data.data);
        this.$message.success("添加成功");
        this.$router.go(-1);
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("添加失败");
        }
      });
    },
    changeDev() {
      const params = {
        'name':this.devName,
        'did':this.devMac,
        'pid':this.edi_pid,
        'projectId':localStorage.getItem("projectId")
      };
      if (this.edi_floorId || this.edi_roomId) {
        if (this.edi_roomId) {
          params['roomId'] = this.edi_roomId;
        } else {
          params['floorId'] = this.edi_floorId;
        }
      } else {
        this.$message.error("请先选择楼栋或者房间");
        return;
      }
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.updateDevice,params,headers).then(res => {
        console.log(res.data.data);
        this.$message.success("修改成功");
        this.$router.go(-1);
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("修改失败");
        }
      });
    },
    onBack() {
      this.$router.go(-1);
    },
    initView(area_type = "") {
      if (area_type === 'build') {
        this.edi_floorId = "";
        this.edi_roomId = "";
      } else if (area_type === 'floor') {
        this.edi_roomId = "";
      }
      let l = [];
      let l_d = this.li_buildInfo;
      for (let i = 0; i < l_d.length; i++) {
        let d = {
          value:l_d[i]['id'],
          label:l_d[i]['name']
        };
        l.push(d);
      }
      this.li_floor = l;
      l = [];
      for (let j = 0; j < l_d.length; j++) {
        if (this.edi_floorId && l_d[j]['id'] !== this.edi_floorId) {
          continue;
        }
        for (let k = 0; k < l_d[j]['rooms'].length; k++) {
          let d = {
            value:l_d[j]['rooms'][k]['id'],
            label:l_d[j]['rooms'][k]['name']
          };
          l.push(d);
        }
      }
      this.li_room = l;
    },
    getPid() {
      if (this.pidPage > this.pidTotal / 10 + 1) {
        return;
      }
      const params = {
        'page':this.pidPage,
        'pageSize':this.pidPageSize
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      this.$api.post(this.$urls.ip + this.$urls.getPidList,params,headers).then(res => {
        console.log(res.data.data);
        this.pidTotal = res.data.data["total"];
        let data = res.data.data.list;
        let l = this.li_pid;
        for (let i = 0; i < data.length; i++) {
          let d = {
            value:data[i]['pid'],
            label:data[i]['name']
          };
          l.push(d);
        }
        this.li_pid = l;
        this.pidPage += 1;
        this.loading = false;
      }).catch(error => {
        console.log(error.data);
        this.loading = false;
        this.$message.error("获取设备类型失败");
      });
    },
    checkLd() {
      if (!this.edi_buildId) {
        this.$message.info("请先选择楼栋");
      }
    },
    getFloor(area_type = "") {
      const params = {
        "page":1,
        "pageSize":1000,
        "id":this.li_area[this.item]['id'],
        "projectId":localStorage.getItem("projectId")
      };
      if (area_type === "build") {
        params["id"] = this.edi_buildId;
        const headers = {
          'token':localStorage.getItem("token")
        };
        this.$api.post(this.$urls.ip + this.$urls.getBuildingInfo,params,headers).then(res => {
          console.log("楼栋信息：",res.data.data);
          this.li_buildInfo = res.data.data["floors"];
          this.initView(area_type);
        }).catch(error => {
          console.log(error);
          if (error) {
            this.$message.error("获取楼层数据失败");
          }
        });
      } else if (area_type === "floor") {
        this.initView(area_type);
      }
    },
    getBuilding() {
      const params = {
        "page":1,
        "pageSize":1000,
        "projectId":localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      this.$api.post(this.$urls.ip + this.$urls.getBuildingList,params,headers).then(res => {
        console.log(res.data.data);
        this.li_area = res.data.data.list;
        let l_d = this.li_area;
        let l = [];
        for (let i = 0; i < l_d.length; i++) {
          let d = {
            value:l_d[i]['id'],
            label:l_d[i]['name']
          };
          l.push(d);
        }
        this.li_build = l;
        this.item = 0;
        this.getFloor();
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取区域失败");
        }
      });
    },
    scolling() {
      let e = this.$refs.devSonSelect.$refs.scrollbar.$refs.wrap;
      if (this.loading) return; /*loading为真跳过-防止误触*/
      let loadMore = e.scrollHeight - e.scrollTop - 1 <= e.clientHeight;
      if (loadMore) { /*到底时触发 loadMore*/
        this.loadMore();
      }
    },
    loadMore() {
      this.loading = true; // 设置加载状态为 true，防止重复请求
      this.getPid();
    }
  },
  mounted() { /*页面加载时调用*/
    this.getBuilding();
    this.$refs.devSonSelect.$refs.scrollbar.$refs.wrap.addEventListener('scroll',this.scolling); /*绑定下拉组件方法*/
    const value = this.$route.query.key;
    console.log(value);
    if (value === "addDev") {
      this.h_text = "新增设备";
      // this.li_pid = this.$route.query.li_pid
    } else {
      this.h_text = "修改设备信息";
      this.did = this.$route.query.did;
      this.devName = this.$route.query.devName;
      this.devMac = this.$route.query.devMac;
      this.edi_pid = this.$route.query.pid;
      this.li_pid = this.$route.query.li_pid;
      if (this.$route.query.buildId) {
        this.edi_buildId = parseInt(this.$route.query.buildId);
      }
      if (this.$route.query.floorId) {
        this.edi_floorId = parseInt(this.$route.query.floorId);
      }
      if (this.$route.query.roomId) {
        this.edi_roomId = parseInt(this.$route.query.roomId);
      }
    }
  },
  beforeDestroy() { /*页面结束时调用*/

  }
};
</script>

<style>
#glDevListSon {
  height: 100vh;
  margin: 0;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 0;
  background: #F4F4F4;
}

.div_main {
  background: #F4F4F4;
  height: auto;
  margin-bottom: 80px;
  border-radius: 5px 5px 5px 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/gls/glDevListSon.vue